// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const SOMETHING_WENT_WRONG_GOING_TO_RELOAD = "Je n\u00e1m \u013e\u00fato, ale nie\u010do sa pokazilo. Mus\u00edme ti znovu na\u010d\u00edta\u0165 t\u00fato str\u00e1nku.";
